<template>
  <div id="container" style="height: 900px" ref="myChart"></div>
</template>
  <script>
export default {
  data() {
    return {
      option: null
    };
  },
  mounted() {
    this.gerenzhongxin();
  },
  methods: {
    gerenzhongxin() {
      let myChart = this.$echarts.init(this.$refs.myChart);
      this.option = {
        legend: {},
        tooltip: {},
        dataset: {
          source: [
            ["月份", "1月", "2月", "3月", "4月", "5月"],
            ["方案设计师", 111, 112, 212, 214, 222],
            ["桥梁博士", 424, 500, 888, 777, 223],
            ["公路工程BIM设计系统", 277, 577, 588, 458, 333]
          ]
        },
        xAxis: [
          { type: "category", gridIndex: 0 },
          { type: "category", gridIndex: 1 }
        ],
        yAxis: [{ gridIndex: 0 }, { gridIndex: 1 }],
        grid: [{ bottom: "55%" }, { top: "55%" }],
        series: [
          // These series are in the first grid.
          { type: "bar", seriesLayoutBy: "row" },
          { type: "bar", seriesLayoutBy: "row" },
          { type: "bar", seriesLayoutBy: "row" },
          { type: "bar", seriesLayoutBy: "row" },
          // These series are in the second grid.
          { type: "bar", xAxisIndex: 1, yAxisIndex: 1 },
          { type: "bar", xAxisIndex: 1, yAxisIndex: 1 },
          { type: "bar", xAxisIndex: 1, yAxisIndex: 1 },
          { type: "bar", xAxisIndex: 1, yAxisIndex: 1 },
          { type: "bar", xAxisIndex: 1, yAxisIndex: 1 }
        ]
      };
      if (this.option && typeof this.option === "object") {
        myChart.setOption(this.option, true);
      }
    }
  }
};
</script>
<style scoped>
#container {
  padding: 11px 2px 11px 0px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 2px rgba(10, 16, 20, 0.24), 0 0 2px rgba(10, 16, 20, 0.12);
  box-sizing: border-box;
  transition: box-shadow 0.5s;
  max-width: 100%;
  min-width: 262px;
  margin: 24px 8px;
  padding-bottom: 48px;
  position: relative;
}
</style>